import "./styles.scss";
import { mainStore } from "../../mainStore";
import { observer } from "mobx-react-lite";
import { gsap } from "gsap";

export const ErrorMsg = observer(() => {
  if (!mainStore.errorMsg) {
    return;
  }
  gsap.delayedCall(2, () => mainStore.setErrorMsg(null));
  return (
    <div className={"err-msg-container"}>
      <svg
        className="err-icon"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
      <p>{mainStore.errorMsg}</p>
    </div>
  );
});
